module.exports = __webpack_public_path__ + "static/curbix-bg-e0fe922644e73f81114cd747f2f5a3f5.png";